import { Button, InputBase, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { AccAddress } from '@terra-money/terra.js'
import CoreModal from 'core/CoreModal'
import { useEffect, useState } from 'react'
import { gatewayService } from 'services/gatewayService'
import CheckedIcon from 'assets/icons-color/checked.png'
import WrongIcon from 'assets/icons-color/wrong.png'
import { useConnectedWallet } from '@terra-money/wallet-provider'

interface Props {
  amount: number
  onClose: () => void
  sendInvite: Function
}

enum BtnState {
  default = 'Add to whitelist',
  checking = 'Checking...',
  inValid = 'Invalid address',
  noInviteLeft = 'No invitation left',
  alreadyWhitelist = 'Already on the whitelist',
}

const InvitationModal = ({ amount, onClose, sendInvite }: Props) => {
  const connectedWallet = useConnectedWallet()
  const [addr, setAddr] = useState<string>('')
  const [validAddr, setValidAddr] = useState<boolean>(false)
  const [disabledBtn, setDisabledBtn] = useState<boolean>(true)
  const [state, setState] = useState<BtnState>(BtnState.default)

  useEffect(() => {
    if (!addr || addr === '' || amount === 0) {
      setValidAddr(false)
      setDisabledBtn(true)
      setState(BtnState.default)
      return
    }
    setState(BtnState.checking)

    const checkAddr = async () => {
      const res = await gatewayService.getWhitelistStatus(addr)
      if (res) {
        setDisabledBtn(true)
        setState(BtnState.alreadyWhitelist)
      } else {
        setDisabledBtn(false)
        setState(BtnState.default)
      }
    }

    if (AccAddress.validate(addr)) {
      setValidAddr(true)
      checkAddr()
    } else {
      setValidAddr(false)
      setDisabledBtn(true)
      setState(BtnState.inValid)
    }
  }, [addr, amount])

  const handleOnChange = (e: any) => {
    setAddr(e.target.value)
  }

  const handleOnClick = () => {
    if (!validAddr) return
    sendInvite(addr)
    onClose()
  }

  const handleOnByPass = () => {
    sendInvite(addr)
    onClose()
  }

  const byPass =
    connectedWallet?.terraAddress ===
    'terra16k92gt69fr02tsgy8sd6lvnzzuv5n0n6rr5z9l'

  const Content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
        textAlign: 'left',
        gap: '24px',
      }}
    >
      <Typography variant="h5"> {amount} Invitations left </Typography>

      <Typography variant="caption">
        Give your friends access to the first community-based pool on Terra
      </Typography>
      <InputBase
        placeholder="Wallet address"
        onChange={handleOnChange}
        endAdornment={
          validAddr &&
          (disabledBtn ? (
            <img src={WrongIcon} alt="WrongIcon" width={24} height={24} />
          ) : (
            <img src={CheckedIcon} alt="CheckedIcon" width={24} height={24} />
          ))
        }
        sx={{
          backgroundColor: '#F6F6F6',
          borderRadius: '8px',
          padding: '16px',
        }}
      />
      <Button
        variant="contained"
        onClick={byPass ? handleOnByPass : handleOnClick}
        disabled={disabledBtn && !byPass}
      >
        {state}
      </Button>
    </Box>
  )
  return <CoreModal open content={Content} onClose={onClose} />
}

export default InvitationModal
